import { EnhancedStore, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import AuthenticationReducer from 'store/AuthenticationSlice';
import ClientReducer from 'store/ClientsSlice';
import CustomizerReducer from 'store/customizer/CustomizerSlice';
import MarcaReducer from 'store/MarcaSlice';

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    auth: AuthenticationReducer,
    client: persistReducer({ key: 'client', storage }, ClientReducer),
    payloadMarques: MarcaReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
}) as EnhancedStore;

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
